$(() => {
  if ($('#page_my-learners_daily_report').length === 0) {
    return;
  }

  const params = $('#daily_report_parameters_holder');
  const date = params.data('date');
  const learner_id = params.data('learner-id');
  const $courseTable = $('table.aya-course-table');

  $('.daily-report-topic-select').on('change', function (this) {
    const $elem = $(this);
    const course_id = $elem.data('course-id');
    const topic_id = $elem.val();

    const url = topic_id
      ? `/api/learners/${learner_id}/reports/daily/${date}/courses/${course_id}/topics/${topic_id}`
      : `/api/learners/${learner_id}/reports/daily/${date}/courses/${course_id}`;

    $.ajax(url).done((data) => {
      const $row = $courseTable
        .find('tr')
        .filter((_n, elem) => $(elem).data('course-id') === course_id);
      $row
        .find('.aya-report-table-watched-seconds .cell-value')
        .text(data.formatted_watched_time);
      $row
        .find('.aya-report-table-watched-count .cell-value')
        .text(data.watched_count);
      $row
        .find('.aya-report-table-answered-count .cell-value')
        .text(data.answered_count);
      $row
        .find('.aya-report-table-correct-percent .cell-value')
        .text(data.formatted_correct_percent);
    });
  });
});
